import { render, staticRenderFns } from "./EmployeeEvents.vue?vue&type=template&id=15319441"
import script from "./EmployeeEvents.vue?vue&type=script&lang=js"
export * from "./EmployeeEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports